module.exports = __webpack_public_path__ + "img/error.5b9d68cb.png";